document.addEventListener('DOMContentLoaded', function () {
  if (!window.location.pathname.includes('/interlock-book-appointment')) return;

  console.log("🚦 Watching for form-embed...");

  const carModelMap = {
    "ACURA": ["TSX"],
    "ALFA ROMEO": ["GIULIA", "GIULIETTA", "MITO", "STELVIO"],
    "AUDI": ["A1", "A3", "A4", "A5", "A6", "A7", "Q2", "Q3", "Q5", "Q7", "TT"],
    "BMW": ["1-SERIES", "2-SERIES", "2-SERIES ACTIVE TOURER", "2-SERIES GRAN TOURER", "3-SERIES", "4-SERIES", "5-SERIES", "6-SERIES", "7-SERIES", "I3", "I8", "M2", "X1", "X2", "X3", "X4", "X5", "X6", "Z4"],
    "BUICK": ["CASCADA", "ENCORE", "ENVISION"],
    "CADILLAC": ["CTS", "SRX"],
    "CHEVROLET": ["ASTRA", "AVEO", "CAMARO", "COLORADO", "CRUZE", "EQUINOX", "GRAND VITARA SZ", "MALIBU", "ORLANDO", "S-10", "SONIC", "SPARK", "SS", "TRACKER", "TRAILBLAZER", "TRAX", "VOLT"],
    "CHRYSLER": ["200", "300", "300C", "ASPEN", "GRAND-VOYAGER", "SEBRING", "TOWN AND COUNTRY"],
    "CITRON": ["BERLINGO", "C-ELYSE", "C-ZERO", "C1", "C2", "C3", "C3 AIRCROSS", "C3 PICASSO", "C3 PLURIEL", "C4", "C4 AIRCROSS", "C4 CACTUS", "C4 PICASSO", "C4 SPACETOURER", "C5", "C5 AIRCROSS", "C6", "C8", "DISPATCH", "DS 3", "DS 3 CROSSBACK", "DS 4", "DS 5", "DS 7 CROSSBACK", "GRAND C4 PICASSO", "GRAND C4 SPACETOURER", "JUMPER", "JUMPY", "RELAY", "SPACETOURER", "XSARA PICASSO"],
    "CUPRA": ["ATECA", "BORN", "FORMENTOR", "LEON", "TAVASCAN"],
    "DACIA": ["DOKKER", "DOKKER STEPWAY", "DUSTER", "JOGGER", "LODGY", "LODGY STEPWAY", "LOGAN", "SANDERO", "SANDERO STEPWAY", "SPRING"],
    "DAEWOO": ["REXTON"],
    "DAIHATSU": ["MATERIA", "MIRA", "SIGRA", "SIRION", "TERIOS", "YRV"],
    "DODGE": ["AVENGER", "CALIBER", "CARAVAN", "CHALLENGER", "CHARGER", "DAKOTA", "DART", "DURANGO", "GRAND-CARAVAN", "JOURNEY", "MAGNUM", "NITRO", "RAM", "VIPER"],
    "FIAT": ["124", "500", "500C", "500E", "500L", "500X", "600", "600E", "ABARTH 500", "ABARTH 500E", "DUCATO", "E-DUCATO", "GRANDE PUNTO", "LINEA", "PANDA", "PUNTO", "PUNTO EVO", "SEDICI", "TALENTO", "TIPO"],
    "FORD": ["B-MAX", "C-MAX", "E-TOURNEO CUSTOM", "E-TRANSIT BUSS", "ECOSPORT", "EDGE", "ENDURA", "FIESTA", "FOCUS", "GALAXY", "KA+", "KUGA", "MONDEO", "MUSTANG", "MUSTANG MACH-E", "PUMA", "RANGER", "S-MAX", "TOURNEO", "TOURNEO COURIER", "TOURNEO CUSTOM", "TOURNERO", "TRANSIT", "TRANSIT BUSS", "TRANSIT CONNECT", "TRANSIT COURIER", "TRANSIT CUSTOM", "TRANSIT TOURNEO CONNECT"],
    "GMC": ["TERRAIN"],
    "HOLDEN": ["BARINA", "CASCADA", "COLORADO 7", "COMMODORE", "CRUZE", "SPARK", "TRAILBLAZER", "TRAX", "VOLT"],
    "HONDA": ["ACCORD", "BALLADE", "BR-V", "BREEZE", "CITY", "CIVIC", "CLARITY", "CR-V", "CR-Z", "E", "FIT", "FREED", "HR-V", "INSIGHT", "INSPIRE", "JAZZ", "MOBILIO", "ODYSSEY", "PASSPORT", "PILOT", "RIDGELINE", "SPIRIOR", "STEPWGN"]
  };

  const observer = new MutationObserver(() => {
    const formEmbed = document.querySelector('form-embed');
    if (!formEmbed || !formEmbed.shadowRoot) return;

    const shadow = formEmbed.shadowRoot;
    const inlineSection = shadow.querySelector('section._inline_stahb_47');
    if (inlineSection) {
      inlineSection.style.setProperty('overflow', 'visible', 'important');
    }
    
    const noImageSection = shadow.querySelector('._noImage_stahb_161');
    if (noImageSection) {
      noImageSection.style.setProperty('overflow', 'visible', 'important');
    }
    
    const carModelInput = shadow.querySelector('input#rdc\\#car_model');
    const carMakeToggle = shadow.querySelector('button[aria-controls="tdlv#car_make-selector-dropdown"]');
    const makeDropdown = shadow.querySelector('#tdlv\\#car_make-selector-dropdown');
    const carMakeText = carMakeToggle?.querySelector('span._selectToggleText_1yit2_25');
  
    if (!carModelInput || !carMakeToggle || !carMakeText) return;
    if (shadow.querySelector('#custom-car-model')) return;
  
    console.log("✅ Injecting Car Model Selector");
    
    // Function to close all dropdowns
    const closeAllDropdowns = () => {
      // Close the make dropdown
      if (makeDropdown) {
        makeDropdown.style.display = 'none';
      }
      if (carMakeToggle) {
        carMakeToggle.setAttribute('aria-expanded', 'false');
      }
      
      // Close model dropdown if exists
      const modelDropdown = shadow.querySelector('#rdc\\#car_model');
      const modelToggle = shadow.querySelector('#custom-car-model');
      if (modelDropdown) {
        modelDropdown.style.display = 'none';
      }
      if (modelToggle) {
        modelToggle.setAttribute('aria-expanded', 'false');
      }
    };
  
    // Close dropdowns when clicking outside
    document.addEventListener('mousedown', function(e) {
      // Only proceed if we have the shadow root and our custom element exists
      if (!shadow || !shadow.querySelector('#custom-car-model')) return;
      
      // Check if the click was inside any of our dropdown components
      const isClickInsideDropdown = 
        e.target.closest('.form-embed') || 
        shadow.contains(e.target) && (
          e.target.closest('#tdlv\\#car_make-selector-dropdown') || 
          e.target.closest('button[aria-controls="tdlv#car_make-selector-dropdown"]') ||
          e.target.closest('#rdc\\#car_model') || 
          e.target.closest('#custom-car-model')
        );
      
      if (!isClickInsideDropdown) {
        closeAllDropdowns();
      }
    });
    
    // Create hidden input for Car Make if it doesn't exist
    let carMakeInput = shadow.querySelector('input#tdlv\\#car_make');
    if (!carMakeInput) {
      carMakeInput = document.createElement('input');
      carMakeInput.id = 'tdlv#car_make';
      carMakeInput.name = 'tdlv#car_make';
      carMakeInput.type = 'hidden';
      carMakeInput.value = carMakeText.textContent.trim();
      
      // Insert the hidden input after the car make dropdown
      carMakeToggle.parentNode.appendChild(carMakeInput);
      
      // Set up observer for car make changes
      const carMakeObserver = new MutationObserver(() => {
        carMakeInput.value = carMakeText.textContent.trim();
        
        // Trigger change and input events for the make field
        const changeEvent = new Event('change', { bubbles: true });
        const inputEvent = new Event('input', { bubbles: true });
        carMakeInput.dispatchEvent(inputEvent);
        carMakeInput.dispatchEvent(changeEvent);
      });
      
      carMakeObserver.observe(carMakeText, { childList: true, characterData: true, subtree: true });
    }

    // Hide original input and label
    carModelInput.style.display = "none";
    const label = shadow.querySelector('label[for="label-rdc#car_model"]');
    if (label) label.remove();

    // Container
    const container = document.createElement("div");
    container.className = "_selectContainer_1yit2_6";
    container.style.position = "relative";

    // Label
    const newLabel = document.createElement("p");
    newLabel.className = "_label_1yit2_10";
    newLabel.textContent = "Car Model";

    // Toggle button
    const toggle = document.createElement("button");
    toggle.type = "button";
    toggle.className = "_selectToggle_1yit2_25";
    toggle.style.position = "relative";
    toggle.id = "custom-car-model";
    toggle.setAttribute("aria-expanded", "false");
    toggle.setAttribute("aria-controls", "rdc#car_model");

    const span = document.createElement("span");
    span.className = "_selectToggleText_1yit2_25";
    span.textContent = "";

    const arrow = document.createElement("span");
    arrow.className = "_arrowDownIcon_1yit2_19";
    arrow.innerHTML = `<svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.09832 0.470704L0.901685 0.470703C0.15069 0.470703 -0.269991 1.22421 0.193991 1.73831L3.29231 5.17126C3.65265 5.57052 4.34735 5.57052 4.70769 5.17126L7.80601 1.73831C8.26999 1.22421 7.84931 0.470704 7.09832 0.470704Z" fill="#5C5F62"/></svg>`;

    toggle.appendChild(span);
    toggle.appendChild(arrow);

    // Dropdown list
    const dropdown = document.createElement("ul");
    dropdown.id = "rdc#car_model";
    dropdown.style.position = "absolute";
    dropdown.style.top = "100%";
    dropdown.style.left = "0";
    dropdown.style.right = "0";
    dropdown.style.zIndex = "1000";
    dropdown.style.background = "#fff";
    dropdown.style.border = "1px solid #ccc";
    dropdown.style.boxShadow = "0px 4px 8px rgba(0,0,0,0.1)";
    dropdown.style.padding = "0";
    dropdown.style.margin = "4px 0 0 0";
    dropdown.style.display = "none";
    dropdown.style.listStyle = "none";
    dropdown.style.maxHeight = "200px";
    dropdown.style.overflowY = "auto";
    dropdown.style.borderRadius = "4px";

    // Inject into DOM
    container.appendChild(newLabel);
    container.appendChild(toggle);
    container.appendChild(dropdown);
    carModelInput.parentNode.insertBefore(container, carModelInput.nextSibling);

    // Remove error message and fix parent class
    const updateValidationState = () => {
      const errorOutput = carModelInput.parentNode.querySelector('output[role="alert"]');
      if (errorOutput) errorOutput.style.display = 'none';
      
      // Remove error styling from parent container
      const parentContainer = carModelInput.closest('._formFieldContainer_1ydxd_5');
      if (parentContainer && parentContainer.classList.contains('_withError_1ydxd_16')) {
        parentContainer.classList.remove('_withError_1ydxd_16');
      }
    };
    
    // Update dropdown based on Make
    const updateModels = () => {
      const selectedMake = carMakeText.textContent?.trim();
      span.textContent = "";
      carModelInput.value = "";
      dropdown.innerHTML = "";

      if (!carModelMap[selectedMake]) {
        toggle.disabled = true;
        return;
      }

      toggle.disabled = false;

      carModelMap[selectedMake].forEach(model => {
        const li = document.createElement("li");
        li.textContent = model;
        li.style.padding = "8px 12px";
        li.style.cursor = "pointer";

        li.addEventListener("mousedown", (e) => {
          e.preventDefault(); // Prevent focus issues
          span.textContent = model;
          
          // Set the value and trigger proper events
          carModelInput.value = model;
          carModelInput.setAttribute("aria-invalid", "false");
          
          // Trigger change and input events to notify form validation
          const changeEvent = new Event('change', { bubbles: true });
          const inputEvent = new Event('input', { bubbles: true });
          carModelInput.dispatchEvent(inputEvent);
          carModelInput.dispatchEvent(changeEvent);
          
          // Update validation UI
          updateValidationState();
          
          dropdown.style.display = "none";
          toggle.setAttribute("aria-expanded", "false");
        });

        li.addEventListener("mouseenter", () => li.style.background = "#f2f2f2");
        li.addEventListener("mouseleave", () => li.style.background = "transparent");

        dropdown.appendChild(li);
      });
    };

    toggle.addEventListener("mousedown", (e) => {
      e.preventDefault(); // Prevent focus issues
      e.stopPropagation();
      const isOpen = toggle.getAttribute("aria-expanded") === "true";
      
      if (!isOpen) {
        // Close all dropdowns
        closeAllDropdowns();
        
        // Then open this one
        dropdown.style.display = "block";
        toggle.setAttribute("aria-expanded", "true");
      } else {
        dropdown.style.display = "none";
        toggle.setAttribute("aria-expanded", "false");
      }
    });

    // Add specific click handler for car make toggle to close model dropdown
    carMakeToggle.addEventListener("mousedown", (e) => {
      // Close model dropdown when opening make dropdown
      dropdown.style.display = "none";
      toggle.setAttribute("aria-expanded", "false");
    });

    const makeObserver = new MutationObserver(updateModels);
    makeObserver.observe(carMakeText, { childList: true, characterData: true, subtree: true });

    updateModels();
    observer.disconnect();
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
